// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__2BOsf","error":"input_error__2OjXj","number-invalid":"input_number-invalid__16NkV"};